import {
	GET_SNAPSHOTS,
	GET_SNAPSHOTS_SUCCESS,
	GET_SNAPSHOTS_FAILURE,
	DELETE_SNAPSHOT_SUCCESS,
	LOAD_MORE_SNAPSHOTS,
	LOAD_MORE_SNAPSHOTS_SUCCESS,
} from './types';

export interface ISnapshot {
	_id: string;
}

export const defaultState = {
	data: [] as ISnapshot[],
	snapToShare: null,
	isLoading: true,
	isLoaded: false,
	error: null,
	totalPages: 1,
	page: 1,
};

export type ISnapshotsState = typeof defaultState;

export const snapshots = (
	state = defaultState,
	action: any
): ISnapshotsState => {
	const { payload } = action;
	switch (action.type) {
		case GET_SNAPSHOTS:
			return {
				...state,
				isLoading: true,
				error: null,
			};
		case GET_SNAPSHOTS_SUCCESS:
			const { page, totalPages, snapshots } = payload;

			return {
				...state,
				data: snapshots,
				isLoading: false,
				isLoaded: true,
				error: null,
				page,
				totalPages,
			};
		case GET_SNAPSHOTS_FAILURE:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case DELETE_SNAPSHOT_SUCCESS:
			return {
				...state,
				data: state.data.filter(snapshot => snapshot._id !== payload),
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case LOAD_MORE_SNAPSHOTS:
			return {
				...state,
				isLoading: true,
				error: null,
			};
		case LOAD_MORE_SNAPSHOTS_SUCCESS:
			const additionalSnapshotsList = payload.snapshots;

			const { data } = state;

			return {
				...state,
				data: [...data, ...additionalSnapshotsList],
				isLoading: false,
				isLoaded: true,
				...payload,
			};
		default:
			return state;
	}
};
